import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { entryGroupsQueryOptions } from "@/shared/cache/slices/autoCombineEntries";
import { useApi } from "@/shared/utils/request";
import { projectedDayTotal } from "@/v2/lib/projectedDayTotal";

interface DayTotalProps {
	date: Date;
	units: number;
	editedGroupId?: string | null;
	timekeeperId?: string | null;
}

export function DayTotal({
	date,
	units,
	editedGroupId,
	timekeeperId,
}: DayTotalProps) {
	const api = useApi();
	const query = useQuery(
		entryGroupsQueryOptions(api, [], true, { timekeeperId }),
	);
	const total = query.data
		? projectedDayTotal(
				query.data,
				format(date, "yyyy-MM-dd"),
				units,
				editedGroupId,
			)
		: null;

	return (
		<p className="flex items-center gap-1 text-xs text-muted-foreground">
			<span>Day total:</span>
			<output
				aria-label="Day total"
				aria-live="polite"
				className="tabular-nums"
			>
				{query.isError ? (
					<span className="text-muted-foreground">Unavailable</span>
				) : total === null ? (
					<span
						className="inline-block h-3 w-16 animate-pulse rounded bg-muted"
						aria-label="Loading day total"
					/>
				) : (
					`${total.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 2 })} hours`
				)}
			</output>
		</p>
	);
}
